<template>
  <div v-if="isShow()" id="post-mark-ad-custom">
    <div class="pt-3">
      <div class="row">
        <span class="col-9 col-lg-9 col-sm-9 col-md-9">
          <input v-model="fields.erid" type="text" class="form-control" placeholder="Введите токен маркировки">
            <span :class="{'is-invalid': v$.erid.$invalid && v$.erid.$dirty}"></span>
            <div class="invalid-feedback" v-for="error of v$.erid.$silentErrors" :key="error.$uid">
              {{ error.$message }}
            </div>
        </span>
        <span class="col-3 col-lg-3 col-sm-3 col-md-3">
          <button class="btn btn-primary" @click="createErid" :class="{'disabled': isProcess()}">
            <div class="loader-item" v-if="isProcess()">
              <div class="spinner-border spinner-border-sm me-2"></div>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-forward me-0"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M15 11l4 4l-4 4m4 -4h-11a4 4 0 0 1 0 -8h1" /></svg>
          </button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import {defineComponent, onMounted, reactive, ref, watch} from "vue"
import Api from "./services/Api"
import Notify from "@/services/Notify"
import {eventBus} from "@/plugins/event_bus/event_bus"
import {eventBindMarkComplete} from "@/modules/post/components/mark_ad/services/data"
import {required} from "@/plugins/vuelidator"
import {useVuelidate} from "@vuelidate/core"
import {
  notesTypeId,
  promocodeTypeId,
  salesTypeId,
  offersTypeId,
  freeTypeId,
  foodAndProductsTypeId,
  banksTypeId,
  gamesTypeId,
  raffleTypeId, articlesTypeId
} from "@/modules/post/services/TypeId"

export default defineComponent({
  name: "MarkAdCustom",
  components: {},
  props: {
    payload: {
      type: Object,
      required: true
    },
  },
  setup(props) {
    let show = ref(false)
    let process = ref(false)
    let fields = reactive(getFields())
    let $externalResults = reactive({})
    let rules = {
      erid: {
        required,
      },
    }
    let v$ = useVuelidate(rules, fields, {$externalResults})

    onMounted(() => {
      updateFields(props.payload)
      onShow()
    })

    watch(() => props.payload, (val) => {
      updateFields(val)
    })

    function validate(fn) {
      clearValidate()
      return v$.value.$validate().then((isValid) => {
        if (isValid === false) {
          return false
        }
        fn()
      })
    }

    function clearValidate() {
      v$.value.$clearExternalResults()
      v$.value.$reset()
    }

    function updateFields(query) {
      fields.post_id = query.post_id
      fields.post_payload = query.post_payload
      fields.channel_id = query.channel_id
      fields.type_id = query.type_id
    }

    function onShow() {
      show.value = true
    }

    function isShow() {
      return show.value === true
    }

    async function createErid() {
      validate(async () => {
        if (confirm("Пост будет сохранен, продолжить?")) {
          onProcess()
          try {
            if (isChannelSite()) {
              //console.log(fields?.post_payload)

              let typeId = fields?.type_id

              if (typeId === salesTypeId) {
                await Api.siteSalesSave(fields?.post_payload)
              } else if (typeId === notesTypeId) {
                await Api.siteNotesSave(fields?.post_payload)
              } else if (typeId === promocodeTypeId) {
                await Api.sitePromocodeSave(fields?.post_payload)
              } if (typeId === offersTypeId) {
                await Api.siteSalesSave(fields?.post_payload)
              } if (typeId === freeTypeId) {
                await Api.siteSalesSave(fields?.post_payload)
              } if (typeId === foodAndProductsTypeId) {
                await Api.siteSalesSave(fields?.post_payload)
              } if (typeId === banksTypeId) {
                await Api.siteSalesSave(fields?.post_payload)
              } if (typeId === gamesTypeId) {
                await Api.siteSalesSave(fields?.post_payload)
              } if (typeId === raffleTypeId) {
                await Api.siteSalesSave(fields?.post_payload)
              } if (typeId === articlesTypeId) {
                await Api.siteArticlesSave(fields?.post_payload)
              } else {
                throw new Error("Неверный тип поста")
              }
            } else {
              await Api.telegramSave(fields?.post_payload)
            }

            try {
              await Api.erid(fields?.post_id, fields?.erid)
              clearForm(["post_id", "post_payload"])
              eventMarkComplete()
              clearValidate()
              Notify.success("Пост успешно промаркирован")
            } catch {
              Notify.error("Ошибка при маркировки")
            } finally {
              offProcess()
            }
          } catch {
            Notify.error("Ошибка при сохранении поста")
          } finally {
            offProcess()
          }
        }
      })
    }

    function eventMarkComplete() {
      eventBus.emit(eventBindMarkComplete, {
        "complete": true,
      })
    }

    function onProcess() {
      process.value = true
    }

    function offProcess() {
      process.value = false
    }

    function isProcess() {
      return process.value === true
    }

    function clearForm(exclude = []) {
      let items = getFields()

      for (let key of Object.keys(items)) {
        if (!exclude.includes(key)) {
          fields[key] = items[key]
        }
      }
    }

    function getFields() {
      return {
        post_id: null,
        post_payload: null,
        erid: null,
        channel_id: null
      }
    }

    function isChannelSite() {
      return fields.channel_id === 1
    }

    return {
      isShow,
      createErid,
      isProcess,
      fields,
      v$,
    }
  },
})
</script>
